export default __webpack_public_path__ + "static/media/logo.26a4c7f7.svg";